
import { computed, defineComponent, PropType, ref, watch } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const __default__ = defineComponent({
  components: {
    FontAwesomeIcon,
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    selectedMode: {
      type: Boolean,
      default: false,
    },
    selectedColors: {
      type: Set as PropType<Set<string>>,
      default: () => new Set(),
    },
  },
  emits: ['selectedColor'],
  setup(props, { emit }) {
    const selected = ref(false);
    const selectedColorsArray = computed(() => Array.from(props.selectedColors || []));
    // Функция для определения темный или светлый цвет
    const isDarkColor = computed(() => {
      if (!props.color) return true; // по умолчанию считаем темным

      try {
        let r, g, b;

        // Обработка hex формата (#ffffff или ffffff)
        if (props.color.startsWith('#')) {
          const hex = props.color.substring(1);
          if (hex.length === 3) {
            // #fff format
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
          } else if (hex.length === 6) {
            // #ffffff format
            r = parseInt(hex.substr(0, 2), 16);
            g = parseInt(hex.substr(2, 2), 16);
            b = parseInt(hex.substr(4, 2), 16);
          } else {
            return true; // невалидный hex
          }
        }
        // Обработка rgb/rgba формата
        else if (props.color.startsWith('rgb')) {
          const match = props.color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (match) {
            r = parseInt(match[1], 10);
            g = parseInt(match[2], 10);
            b = parseInt(match[3], 10);
          } else {
            return true;
          }
        }
        // Обработка названий цветов (basic)
        else if (
          ['white', '#fff', '#ffffff', 'rgb(255,255,255)', 'rgba(255,255,255'].some((c) =>
            props.color.toLowerCase().includes(c.toLowerCase())
          )
        ) {
          return false; // белый цвет - светлый
        } else {
          return true; // другие названия считаем темными
        }

        // Формула восприятия яркости (стандартная)
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        // Если яркость меньше 128 - цвет считается темным
        return brightness < 128;
      } catch (error) {
        console.warn('Error calculating color brightness:', error);
        return true; // по умолчанию темный
      }
    });

    // Цвет галочки зависит от фона
    const checkIconColor = computed(() => {
      return isDarkColor.value ? '#ffffff' : '#000000';
    });

    // Тень для галочки зависит от фона
    const checkIconShadow = computed(() => {
      return isDarkColor.value
        ? '0 1px 2px rgba(0, 0, 0, 0.7)'
        : '0 1px 2px rgba(255, 255, 255, 0.7)';
    });

    const toggle = () => {
      if (props.selectedMode) {
        selected.value = !selected.value;
      }
    };

    const selectedColor = (color: string) => {
      toggle();
      emit('selectedColor', { color: color, selected: selected.value });
    };

    watch(
      selectedColorsArray,
      (value) => {
        if (props.selectedMode) {
          selected.value = value.includes(props.color);
        }
      },
      { immediate: true }
    );
    return {
      selected,
      checkIconColor,
      checkIconShadow,
      selectedColor,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "437b222b": (_ctx.checkIconShadow)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__